import { useCallback, useEffect, useState } from "react";

/**
 * Custom hook that provides the current device position using the Geolocation API.
 *
 * @param fetchOnMount - Determines whether to fetch the device position on component mount.
 * @returns An object containing the current device position, a function to fetch the position, and any error that occurred during fetching.
 */
export function useDevicePosition(fetchOnMount = false) {
  const [position, setPosition] = useState<null | GeolocationPosition>(null);
  const [error, setError] = useState<null | GeolocationPositionError>(null);

  const getPosition = useCallback(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setPosition(pos);
      },
      (err) => {
        setError(err);
      }
    );
  }, []);
  useEffect(() => {
    if (fetchOnMount) {
      getPosition();
    }
  }, [fetchOnMount, getPosition]);
  return { position, getPosition, error };
}
